export default "__VITE_ASSET__d8035c17__"